import { memo } from "react";
import Page from "app/pages/.shared/Page/Page";
import List from "app/pages/.shared/List";
import "./BestMatchGuarantee.scss";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const BestMatchGuarantee = () => {
	return (
		<div className="best-match-guarantee">
			<Page title={<FormattedMessage id="best.match.guarantee.title" />}>
				<p className="best-match-guarantee__paragraph">
					<FormattedMessage id="best.match.guarantee.intro" />
				</p>

				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="best-match-guarantee__title"
					component="h2"
				>
					<FormattedMessage id="best.match.guarantee.1.title" />
				</Typography>

				<p className="best-match-guarantee__paragraph">
					<FormattedMessage id="best.match.guarantee.1.content" />
				</p>

				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="best-match-guarantee__title"
					component="h2"
				>
					<FormattedMessage id="best.match.guarantee.2.title" />
				</Typography>

				<p className="best-match-guarantee__paragraph">
					<List
						items={[
							<FormattedMessage
								key="best.match.guarantee.2.content.1"
								id="best.match.guarantee.2.content.1"
							/>,
							<FormattedMessage
								key="best.match.guarantee.2.content.2"
								id="best.match.guarantee.2.content.2"
							/>,
							<FormattedMessage
								key="best.match.guarantee.2.content.3"
								id="best.match.guarantee.2.content.3"
							/>,
							<FormattedMessage
								key="best.match.guarantee.2.content.4"
								id="best.match.guarantee.2.content.4"
							/>,
							<FormattedMessage
								key="best.match.guarantee.2.content.5"
								id="best.match.guarantee.2.content.5"
							/>,
							<FormattedMessage
								key="best.match.guarantee.2.content.6"
								id="best.match.guarantee.2.content.6"
							/>,
							<FormattedMessage
								key="best.match.guarantee.2.content.7"
								id="best.match.guarantee.2.content.7"
							/>,
						]}
					/>
				</p>

				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="best-match-guarantee__title"
					component="h2"
				>
					<FormattedMessage id="best.match.guarantee.3.title" />
				</Typography>

				<p className="best-match-guarantee__paragraph">
					<List
						items={[
							<FormattedMessage
								key="best.match.guarantee.3.content.1"
								id="best.match.guarantee.3.content.1"
							/>,
							<FormattedMessage
								key="best.match.guarantee.3.content.2"
								id="best.match.guarantee.3.content.2"
							/>,
							<FormattedMessage
								key="best.match.guarantee.3.content.3"
								id="best.match.guarantee.3.content.3"
							/>,
							<FormattedMessage
								key="best.match.guarantee.3.content.4"
								id="best.match.guarantee.3.content.4"
							/>,
						]}
					/>
				</p>

				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="best-match-guarantee__title"
					component="h2"
				>
					<FormattedMessage id="best.match.guarantee.4.title" />
				</Typography>

				<p className="best-match-guarantee__paragraph">
					<FormattedMessage id="best.match.guarantee.4.content.1" />
				</p>

				<p className="best-match-guarantee__paragraph">
					<FormattedMessage id="best.match.guarantee.4.content.2" />
				</p>

				<p className="best-match-guarantee__paragraph">
					<FormattedMessage id="best.match.guarantee.4.content.3" />
				</p>

				<p className="best-match-guarantee__paragraph">
					<FormattedMessage id="best.match.guarantee.4.content.4" />
				</p>

				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="best-match-guarantee__title"
					component="h2"
				>
					<FormattedMessage id="best.match.guarantee.5.title" />
				</Typography>

				<p className="best-match-guarantee__paragraph">
					<FormattedMessage
						id="best.match.guarantee.5.content.1"
						values={{
							link: (
								<a
									target="_blank"
									rel="noopener noreferrer"
									href="mailto:garantieprix@perfectstay.com"
								>
									garantieprix@perfectstay.com
								</a>
							),
						}}
					/>
				</p>
				<p className="best-match-guarantee__paragraph">
					<FormattedMessage id="best.match.guarantee.5.content.2" />
				</p>
				<p className="best-match-guarantee__paragraph best-match-guarantee__paragraph--important">
					<FormattedMessage id="best.match.guarantee.5.content.3" />
				</p>
			</Page>
		</div>
	);
};

export default memo(BestMatchGuarantee);
